import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    this.state = document.body.classList.contains('has-menu')
    this.lastTrigger = null
    this.toggleButtons = Array.from(document.querySelectorAll('[data-navigation-toggle]'))
    this.focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'

    this.setupA11yAttributes()
    this.syncState()

    this.onToggleClick = this.onToggleClick.bind(this)
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this)
    this.onDocumentClick = this.onDocumentClick.bind(this)

    this.toggleButtons.forEach((button) => {
      button.addEventListener('click', this.onToggleClick)
    })

    document.addEventListener('keydown', this.onDocumentKeydown)
    document.addEventListener('click', this.onDocumentClick)
  }

  destroy () {
    this.toggleButtons.forEach((button) => {
      button.removeEventListener('click', this.onToggleClick)
    })

    document.removeEventListener('keydown', this.onDocumentKeydown)
    document.removeEventListener('click', this.onDocumentClick)
  }

  setupA11yAttributes () {
    if (!this.el.id) {
      this.el.id = 'site-navigation'
    }

    this.toggleButtons.forEach((button) => {
      if (!button.getAttribute('type')) {
        button.setAttribute('type', 'button')
      }

      button.setAttribute('aria-controls', this.el.id)
      button.setAttribute('aria-expanded', this.state ? 'true' : 'false')
    })
  }

  syncState () {
    document.body.classList.toggle('has-menu', this.state)

    this.toggleButtons.forEach((button) => {
      button.setAttribute('aria-expanded', this.state ? 'true' : 'false')
    })
  }

  onToggleClick (event) {
    this.lastTrigger = event.currentTarget
    this.toggleMenu()
  }

  onDocumentKeydown (event) {
    if (event.key === 'Escape' && this.state) {
      this.closeMenu({ returnFocus: true })
    }
  }

  onDocumentClick (event) {
    if (!this.state) return

    const clickedLinkInNav = event.target.closest('nav a')
    if (clickedLinkInNav && this.el.contains(clickedLinkInNav)) {
      this.closeMenu()
    }
  }

  toggleMenu () {
    if (this.state) {
      this.closeMenu({ returnFocus: true })
    } else {
      this.openMenu()
    }
  }

  openMenu () {
    this.state = true
    this.syncState()

    const firstFocusableItem = this.el.querySelector(this.focusableSelector)
    if (firstFocusableItem) {
      firstFocusableItem.focus()
    }
  }

  closeMenu ({ returnFocus = false } = {}) {
    this.state = false
    this.syncState()

    if (returnFocus && this.lastTrigger) {
      this.lastTrigger.focus()
    }
  }
}
